export default __webpack_public_path__ + "static/media/portside-avianis.e6f20fa4.png";